import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TURN_TIME_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = {
  definitions: {},
  metrics: [],
};

const turnTimeDefinitionsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case TURN_TIME_DEFINITIONS_ACTION_TYPE.GET_TURN_TIME_DEFINITIONS:
        draft.definitions = payload || {};
        break;

      case TURN_TIME_DEFINITIONS_ACTION_TYPE.CREATE_TURN_TIME_DEFINITION:
      case TURN_TIME_DEFINITIONS_ACTION_TYPE.UPDATE_TURN_TIME_DEFINITION:
        draft.definitions[payload.id] = payload;
        break;

      case TURN_TIME_DEFINITIONS_ACTION_TYPE.DELETE_TURN_TIME_DEFINITION:
        delete draft.definitions[meta.id];
        break;

      case TURN_TIME_DEFINITIONS_ACTION_TYPE.SET_TURN_TIME_METRICS:
        draft.metrics = payload || [];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default turnTimeDefinitionsReducer;
